module.exports = __webpack_public_path__ + "static/media/save.4ce326db.svg";